// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Unicons$Showside from "../../icons/Unicons.bs.js";
import * as IconCart$Showside from "../../icons/IconCart.bs.js";
import * as IconButton$Showside from "../IconButton.bs.js";
import * as StringUtils$Showside from "../../utils/StringUtils.bs.js";
import * as CartAnimation$Showside from "../CartAnimation.bs.js";
import * as NavMenu__Items$Showside from "./NavMenu__Items.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as NavMenu__Topbar$Showside from "./NavMenu__Topbar.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as UseCheckoutAction$Showside from "../../hook/UseCheckoutAction.bs.js";
import * as PausePageScrolling$Showside from "../PausePageScrolling.bs.js";
import * as CartContextProvider$Showside from "../../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function NavMenu__ModalLayout(Props) {
  var children = Props.children;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var items = NavMenu__Items$Showside.useItems(undefined, undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var pdpAddToCartConfirmation = match$1.config.settings.pdpAddToCartConfirmation;
  var match$2 = CartContextProvider$Showside.useCart(undefined);
  var cart = match$2.cart;
  var match$3 = UseCheckoutAction$Showside.useCheckoutAction(undefined);
  var handleCheckoutClick = match$3.onClick;
  var checkoutHref = match$3.href;
  var renderCloseButton = function (param) {
    var match = ctx.mode;
    if (match) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("inline-block px-4 py-2")
      }, React.createElement(IconButton$Showside.make, {
        onClick: function (param) {
          Curry._3(goTo, undefined, undefined, /* NotRendered */0);
        },
        clear: true,
        iconSize: /* Smallest */4,
        labelSize: /* Smallest */4,
        icon: React.createElement(Unicons$Showside.UilTimes.make, {
          size: /* Px */{
            _0: 20
          }
        }),
        label: "Close"
      }));
    } else {
      return React.createElement("div", {
        className: CSS$Showside.prefix("inline-block relative py-4")
      }, React.createElement(IconButton$Showside.make, {
        onClick: function (param) {
          Curry._3(goTo, undefined, undefined, /* NotRendered */0);
        },
        icon: React.createElement(Unicons$Showside.UilTimes.make, {
          size: /* Px */{
            _0: 20
          }
        })
      }));
    }
  };
  var renderCheckoutButton = function (param) {
    if (checkoutHref === undefined && handleCheckoutClick === undefined) {
      return null;
    }
    var tmp = {
      clear: true,
      iconSize: /* Smallest */4,
      icon: React.createElement(IconCart$Showside.make, {
        size: 20
      })
    };
    if (handleCheckoutClick !== undefined) {
      tmp.onClick = Caml_option.valFromOption(handleCheckoutClick);
    }
    var tmp$1 = StringUtils$Showside.fromInt(99, undefined, cart.itemCount);
    if (tmp$1 !== undefined) {
      tmp.badge = Caml_option.valFromOption(tmp$1);
    }
    if (checkoutHref !== undefined) {
      tmp.href = Caml_option.valFromOption(checkoutHref);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("inline-block px-4 py-2 relative")
    }, React.createElement(IconButton$Showside.make, tmp), React.createElement(CartAnimation$Showside.make, {
      productDirection: /* Bottom */1,
      tooltipDirection: /* Left */2,
      addedLabel: pdpAddToCartConfirmation,
      className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full")
    }));
  };
  var match$4 = ctx.mode;
  var paddingX = match$4 || ctx.threeColumnLayout ? undefined : "5%";
  var match$5 = ctx.mode;
  if (match$5) {
    var tmp = {
      className: CSS$Showside.prefix("py-3 text-lg"),
      offset: 9,
      hideOnEmpty: true,
      centered: false
    };
    if (items !== undefined) {
      tmp.items = Caml_option.valFromOption(items);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col h-full overflow-hidden")
    }, ctx.isModalOpen ? React.createElement(PausePageScrolling$Showside.make, {}) : null, React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col sticky top-0 z-10 flex-shrink-0 w-full bg-main")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow")
    }, renderCloseButton(undefined)), React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0")
    }, renderCheckoutButton(undefined))), React.createElement(NavMenu__Topbar$Showside.make, tmp), React.createElement("div", {
      className: CSS$Showside.prefix("absolute pointer-events-none bottom-0 left-0 w-full border-b border-primary opacity-5")
    })), React.createElement("div", {
      className: CSS$Showside.prefix("relative overflow-hidden flex-grow")
    }, children));
  }
  var tmp$1 = {
    maxHeight: CSS$Showside.intToPx(ctx.positions.modalMaxHeight)
  };
  if (paddingX !== undefined) {
    tmp$1.paddingRight = paddingX;
  }
  if (paddingX !== undefined) {
    tmp$1.paddingLeft = paddingX;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("w-full mx-auto flex"),
    style: tmp$1
  }, ctx.isModalOpen ? React.createElement(PausePageScrolling$Showside.make, {}) : null, React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow ml-3 relative overflow-hidden")
  }, children), React.createElement("div", {
    className: CSS$Showside.prefix("flex-shrink-0 px-3")
  }, renderCloseButton(undefined)));
}
NavMenu__ModalLayout.displayName = "NavMenu__ModalLayout";
var make = NavMenu__ModalLayout;
export { make };
/* react Not a pure module */